export const NOTES_MEDIA_STORAGE_QUOTA_CODE = 'NOTES_MEDIA_STORAGE_QUOTA';

export class NoteMediaQuotaError extends Error {
  readonly code = NOTES_MEDIA_STORAGE_QUOTA_CODE;

  constructor(message: string) {
    super(message);
    this.name = 'NoteMediaQuotaError';
  }
}

/** Client-side pre-check before POST /notes/media/sign. */
export function assertNoteMediaUploadFits(
  used: number,
  max: number,
  byteLength: number,
  message?: string
): void {
  if (max <= 0) {
    if (byteLength > 0) {
      throw new NoteMediaQuotaError(
        message ?? 'Note images are not included on the Free plan. Upgrade to add images to notes.'
      );
    }
    return;
  }
  if (used + byteLength > max) {
    throw new NoteMediaQuotaError(
      message ?? 'Note image storage quota exceeded. Remove images or upgrade your plan.'
    );
  }
}
